module.exports = __webpack_public_path__ + "static/media/SUSHI.05f15710.svg";